// const load = require("little-loader");
import * as load from 'little-loader';

export const parallelLoad = (libs, callback) => {
    let finished = 0;
    let errs = [];
  
    if (!(libs && libs.length)) { return callback([]); }
  
    libs.forEach(lib => {
      load(lib, err => {
        // capture errors array and return all to callback.
        // Note: _Could_ do other logic to bail early when first error occurs.
        errs = errs.concat(err ? [err] : []); 
  
        finished++;
        if (finished === libs.length) {
          callback(errs);
        }
      });
    });
  };


// WEBPACK FOOTER //
// ./src/js/utils/parallelLoad.js